/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface UserData { 
    status?: number;
    organization?: string;
    login?: string;
    fullNumber?: string;
    language?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    customerCare?: boolean;
    administrator?: boolean;
    serviceProvider?: boolean;
    vpnAdministrator?: boolean;
    vpnServiceProvider?: boolean;
    vpnEndUser?: boolean;
    attendant?: boolean;
    recordEnabled?: boolean;
}
